/**
 * Canonical funnel paths for this brand.
 *
 * AR home (BaseTemplate) CTA "Exclusivo" (wishlist `community`) always lands here.
 * Keep aliases in App.tsx / Worker for old bookmarks and campaigns.
 */

/** AR exclusive Mux VIP landing (InvitacionExclusivaMux). */
export const AR_EXCLUSIVE_INVITE_PATH = "/invitacion-exclusive" as const;

/**
 * Legacy Spanish slug — still routed, but all new CTAs use AR_EXCLUSIVE_INVITE_PATH.
 * Prefer redirecting to the canonical path when generating links.
 */
export const AR_EXCLUSIVE_INVITE_PATH_LEGACY = "/invitacion-exclusiva" as const;

/** Premium invite alias that also renders InvitacionExclusivaMux. */
export const PREMIUM_MUX_INVITE_PATH = "/invitacion-premium" as const;

/** Paths that must render InvitacionExclusivaMux (Worker inject + SPA). */
export const MUX_EXCLUSIVE_INVITE_PATHS = [
  AR_EXCLUSIVE_INVITE_PATH,
  AR_EXCLUSIVE_INVITE_PATH_LEGACY,
  PREMIUM_MUX_INVITE_PATH,
] as const;

export function isMuxExclusiveInvitePath(
  pathname: string | null | undefined,
): boolean {
  const p = (pathname || "/").split("?")[0].toLowerCase();
  const base = p.length > 1 && p.endsWith("/") ? p.slice(0, -1) : p;
  return (MUX_EXCLUSIVE_INVITE_PATHS as readonly string[]).some(
    (path) => base === path || base.startsWith(`${path}/`),
  );
}
